import Skeleton from './Skeleton';
import Content from './Content';

export {Content};

export default Skeleton;